<template>
  <div>
    <van-nav-bar placeholder title="课程详情" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
      </template>
    </van-nav-bar>
    <van-form @submit="beforeSubmit">
      <div class="detial-box">
        <!--    <div class="top-img" v-if="data.pic">  <img :src="fileDisplayPrefix +  (data.pic || '').split(',')[0]" /></div>-->
        <div class="top-img"><img src="@/assets/topimg.png"></div>
        <div class="title">{{ data.name }}</div>
        <div class="jg-name">
          <span><i></i>{{ data.classTime }}</span>
        </div>
        <div class="per-box">
          <span>{{ data.institutionName }} . 共{{ data.classHour }}课时</span>
          <div class="pre">￥{{ data.price }}</div>
        </div>
        <div class="techer">
          <b class="clearfiex">任课老师</b>
          <span>
        <em>{{ data.teacherName }}</em>
      </span>
        </div>
        <div class="kc-detial">
          <b class="clearfiex">课程详情</b>
          <dl>
            <dt>上课地点：</dt>
            <dd>{{ data.address }}</dd>
          </dl>
          <dl>
            <dt>开班日期：</dt>
            <dd>{{ data.startDate }}</dd>
          </dl>
          <dl>
            <dt>课程简介：</dt>
            <dd>{{ data.introduction }}</dd>
          </dl>
          <div v-if="data.pic" class="d-img">
            <img v-for="(e,i) in data.pic.split(',')" :key="i" :src="fileDisplayPrefix +  e"/>
          </div>
        </div>
        <div class="bming">
          <b class="clearfiex">报名</b>
          <van-field
              v-model="data.studentName"
              label="学生姓名"
              placeholder="学生姓名"
              :rules="[{ required: true, message: '请填写学生姓名' }]"
          />
          <van-field
              v-model="data.identifyCardNo"
              label="身份证号码"
              placeholder="身份证号码"
              :rules="[{ required: true, message: '请填写身份证号码' }, {validator, message: '身份证号码格式错误！'}]"
          />
        </div>
        <div style="height:65px"></div>
        <div class="bm-but-box">
      <span>
        <p>名额：<b>{{ data.planCount }}</b></p>
        <p>报名人数：<b>{{ data.realCount }}</b></p>
      </span>
          <van-button round block type="info" :loading="isButton" :disabled="isButton" class="tj-but"
                      native-type="submit">提交
          </van-button>
        </div>
      </div>

    </van-form>

    <!--提交预约二次确认-->
    <van-dialog v-model="submitShow" show-cancel-button :show-confirm-button="submitChecked" @confirm="onSubmit">
      <div class="van-content">
        <h6 style="text-align: center;font-weight: bold">{{ agreement.title || '提示' }}</h6>
        <template v-if="agreement.content">
          <p v-for="(item, index) in agreement.content.split('\n')" :key="index">
            <span v-html="item"></span>
          </p>
        </template>
        <p>本平台主要用于资金监管，实际的培训服务以机构和家长约定内容为准。</p>
      </div>
      <div class="v-checkbox">
        <van-checkbox v-model="submitChecked">本人已认真阅读、充分了解并自愿接受上述规定。</van-checkbox>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {FILE_DISPLAY_PREFIX} from "../../api/upload";
import {addApply, getCourseTranslationById, getAgreement} from "../../api/courseSelection/courseSelection";

export default {
  name: "detail",
  data() {
    return {
      isButton: false,
      data: {},
      fileDisplayPrefix: FILE_DISPLAY_PREFIX,
      submitChecked: false,
      submitShow: false,
      agreement: {}
    }
  },
  created() {
    this.data.id = this.$route.query.id

    getCourseTranslationById(this.$route.query.id).then(res => {
      if (res.code === 10000) {
        this.data = res.result

        getAgreement(this.data.institutionId).then(res => {
          if (res.code === 10000) {
            this.agreement = res.result || {}
          }
        })
      }
    })
  },
  methods: {
    //身份证号验证
    validator(val) {

      const card15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
      const card18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (val) {
        return card15.test(val) || card18.test(val)
      }
    },


    onClickLeft() {
      this.$router.push({path: `/courseSelection`})
    },

    beforeSubmit() {
      this.submitChecked = false
      this.submitShow = true
    },
    onSubmit() {
      this.isButton = true
      const data = {
        studentName: this.data.studentName,
        identifyCardNo: this.data.identifyCardNo,
        classHour: this.data.classHour,
        institutionId: this.data.institutionId,
        curriculumId: this.data.id,
        price: this.data.price,
        leftHour: this.data.classHour
      }
      addApply(data).then(res => {
        if (res.code === 10000) {
          this.$toast("报名成功!");
          this.$router.push({path: `/course/unpaid?id=${res.result}`})
          this.isButton = false
        }
      }).finally(() => {
        this.isButton = false
        setTimeout(() => {
          this.loading = false
        }, 200)
      });

    },
  }
}

</script>

<style scoped>
.per-box{
  display: flex;
  align-items: center;
  height: 40px;
  background: #FF9900;
  position: relative;
}
.pre {
  position: absolute;
  right: 0;
  bottom:1px;
  border-radius: 100px 0 0 0;
  height:45px;
  background: #FF6600;
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  padding: 0 35px;
  display: flex;
  align-items: center;
  color: #ffffff;
}
.per-box span{
  display: flex;
  align-items: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size:14px;
  color: #FFFFFF;
  padding-left: 11px;
}
/deep/ .van-field__body {
  display: flex;
  flex: 1;
}

.bm-but-box {
  display: flex;
  padding: 0 14px;
  align-items: center;
  justify-content: space-between;
  height: 66px;
  border-top: 1px solid #dedede;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: #ffffff;
  z-index: 999999;
}

.bm-but-box span {
  display: flex;
  align-items: center;
}

.bm-but-box span p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-right: 10px;
}

/deep/ .tj-but {
  display: flex;
  padding: 0 3px;
  background: #FF9900;
  border-radius: 25px;
  width: 130px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border: none;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}

/deep/ .bming .van-cell {
  padding: 0;
  height: 50px;
  display: flex;
  align-items: center;
}

/deep/ .bming .van-cell::after {
  border: none;
}

/deep/ .bming .van-cell__value {
  border: 1px solid #dedede;
  border-radius: 3px;
  height: 34px;
  display: flex;
  align-items: center;
  padding: 0 5px;
}

.techer {
  display: flex;
  flex-direction: column;
  padding: 20px 14px;
  border-bottom: 5px solid #f8f8f8;
}

.techer b {
  display: flex;
  height: 15px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 15px;
}
.techer b::before{
  width: 3px;
  height:16px;
  background: #67C86F;
  border-radius: 3px;
  margin-right: 5px;
}
.techer span {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.techer span em {
  display: flex;
  height: 28px;
  background: #F4F5F7;
  border-radius: 100px;
  padding: 0 11px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  align-items: center;
  margin-right: 9px;
}

.top-img {
  display: flex;
  margin: 10px;
  height: 236px;
  height: 63vw;
  overflow: hidden;
  border-radius: 16px;
}

.title {
  display: flex;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  padding: 20px 14px 15px 14px;
}

.jg-name {
  display: flex;
  align-items: center;
  padding:0 14px 19px 14px;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
}

.jg-name span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #484848;
  display: flex;
  align-items: center;
}
.kc-detial {
  padding: 20px 14px;
  border-bottom: 5px solid #f8f8f8;
}

.kc-detial b {
  display: flex;
  height: 15px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 15px;
}
.kc-detial b::before{
  width: 3px;
  height:16px;
  background: #67C86F;
  border-radius: 3px;
  margin-right: 5px;
}
.kc-detial dl {
  display: flex;
  margin-bottom: 10px;
}

.kc-detial dl dt {
  display: flex;
  font-size: 14px;
  color: #777777;
  width: 70px;
  padding-top: 3px;
}

.kc-detial dl dd {
  display: flex;
  flex: 1;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  flex-wrap: wrap;
  word-wrap: break-word;
  word-break: break-all
}

.d-img img {
  width: 100%;
  margin-bottom: 5px;
}

.bming {
  display: flex;
  flex-direction: column;
  padding: 20px 14px;
  border-bottom: 5px solid #f8f8f8;
}

.bming b {
  display: flex;
  height: 15px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 15px;
}
.bming b::before{
  width: 3px;
  height:16px;
  background: #67C86F;
  border-radius: 3px;
  margin-right: 5px;
}
.van-content {
  padding: 22px;
  max-height: 60vh;
  overflow-y: auto;
}

.van-content h6 {
  font-weight: bold;
  color: #000000;
  font-size: 12px;
  line-height: 21px;
  margin-bottom: 10px;
}

.van-content p {
  font-size: 12px;
  line-height: 21px;
  margin-bottom: 5px;
}

.v-checkbox {
  padding: 10px 10px;
  border-top: 1px solid #dedede;
}

/deep/ .van-checkbox__label {
  font-size: 12px;
}

/deep/ .van-checkbox__icon {
  font-size: 16px;
}
</style>
